import { FC, ReactNode, Dispatch } from 'react';
import { Toast } from 'react-bootstrap';
import style from './Toast.module.scss';

type ToastProps = {
  message?: string|null;
  isDisplayToast: boolean;
  setIsDisplayToast: Dispatch<React.SetStateAction<boolean>>;
}

const ToastContainer:FC<ToastProps> = (props) => {
  const { message, isDisplayToast, setIsDisplayToast } = props;

  return (
    <div style={{textAlign: 'center'}}>
      <Toast
        onClose={() => setIsDisplayToast(false)}
        show={isDisplayToast}
        className={ `${style.toast}` }
        delay={3000}
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">{message}</strong>
        </Toast.Header>
      </Toast>
    </div>
  );
}

ToastContainer.defaultProps = {
  message: '完了しました'
}


export default ToastContainer;
